import TemplateView from "../../../TemplateView";
import {AccessRights} from "../../../constants";
import {generatePermissionRows, getGenerateMoneyReportsRightTitle, getManagePtoAndSickDaysRightTitle} from "../../../permissions/PermissionsUtils"

export default class PermissionsBlock extends TemplateView {
    constructor($containerEl, {
        permissionRowMouseIn = () => {},
        permissionRowMouseOut = () => {}
    }) {
        super($containerEl);

        this.state = {
            accessRights: [],
            editLoggedIn: false,
            disabled: false,
            readOnly: false,
            isURAEnabled: false,
            isBTYEnabled: false,
            isLTTEnabled: false,
            isPTOEnabled: false,
            isSDBEnabled: false,
        }

        this.params = {
            permissionRowMouseIn,
            permissionRowMouseOut
        }

        this.onStatePropertyChanged('accessRights', () => {
            Object.values(this.permissionRows).map((row) => row.setState({checked: false}));

            for (let accessRight of this.state.accessRights) {
                if (this.permissionRows[accessRight])
                    this.permissionRows[accessRight].setState({checked: true});
            }
        })
        this.onStatePropertyChanged('editLoggedIn', () => {
            this.permissionRows[AccessRights.MANAGE_USERS].setState({disabled: this.state.editLoggedIn || this.state.readOnly});
        })

        this.onAnyStatePropertyChanged(['disabled', 'readOnly'], ({disabled, readOnly}) => {
            this._switchDisabledStateOfPermissionsRows(disabled || readOnly)
            this.permissionRows[AccessRights.MANAGE_USERS].setState({disabled: this.state.editLoggedIn || disabled || readOnly});
        })

        this.onAnyStatePropertyChanged(['isURAEnabled', 'isBTYEnabled'], ({isURAEnabled, isBTYEnabled}) => {
            this.permissionRows[AccessRights.GENERATE_MONEY_REPORTS].toggle(isURAEnabled || isBTYEnabled)
            this.permissionRows[AccessRights.GENERATE_MONEY_REPORTS].setState({
                name: getGenerateMoneyReportsRightTitle(isURAEnabled, isBTYEnabled)
            })
        })

        this.onStatePropertyChanged('isLTTEnabled', (enabled) => {
            this.permissionRows[AccessRights.LOCK_TIME_TRACK].toggle(enabled)
        })

        this.onAnyStatePropertyChanged(['isPTOEnabled', 'isSDBEnabled'], ({isPTOEnabled, isSDBEnabled}) => {
            this.permissionRows[AccessRights.MANAGE_PTO_AND_SICK].toggle(isPTOEnabled || isSDBEnabled)

            this.permissionRows[AccessRights.MANAGE_PTO_AND_SICK].setState({
                name: getManagePtoAndSickDaysRightTitle(isPTOEnabled, isSDBEnabled)
            })
        })

        this.onStatePropertyChanged('readOnly', (readOnly) => {
            this.$permissionTemplatesMenuButton.toggle(!readOnly)
        })
    }

    templateHtml() {
        return "<div class='permissionsBlock block'>" +
               "    <div class='blockHeader'>" +
               "        <div class='label'><%=headerLabel%></div>" +
               "        <div class='templatesButton'>" +
               "            <div class='icon'/><div class='applyTemplate'><%=applyTemplateBtnText%></div>" +
               "        </div>" +
               "    </div>" +
               "    <div class='blockContent'>" +
               "        <div class='firstGroup permissionGroup'/>" +
               "        <div class='secondGroup permissionGroup'/>" +
               "    </div>" +
               "    <div class='permissionsInfoButton'><%=permissions_info_button_text%></div>" +
               "</div>";
    }

    afterRender() {
        super.afterRender();
        this.$firstGroup = this.find('.firstGroup');
        this.$secondGroup = this.find('.secondGroup');
        this.permissionRows = generatePermissionRows(this.$firstGroup, this.$secondGroup);
        this.$permissionTemplatesMenuButton = this.find('.templatesButton')

        Object.values(this.permissionRows).map((row) => {
            row.on('changed',
                (e, id, active) => {
                    row.setState({checked: active})
                    let rights = this.state.accessRights.slice();
                    const index = rights.indexOf(row.id);
                    if (active && index === -1)
                        rights.push(row.id);
                    if (!active && index !== -1)
                        rights.splice(index, 1);
                    this.setStateInternal({accessRights: rights});
                    this.trigger('permissionsChanged', [rights, this.state.editLoggedIn]);
                })
            row.$el.mouseover(() => {
                this.params.permissionRowMouseIn(row.getId())
            })
            row.$el.mouseout(() => {
                this.params.permissionRowMouseOut(row.getId())
            })
        });

        this.renderInitialState()
    }

    messageKeys() {
        return {
            headerLabel: "userlist.userdata.permissions",
            permissions_info_button_text: "user.panel.permissions.permissions_info_button_text",
            applyTemplateBtnText: "userlist.userdata.permissions_templates.apply_template"
        }
    }

    _switchDisabledStateOfPermissionsRows(disabled) {
        Object.values(this.permissionRows).map((row) => {
            row.setState({
                disabled: disabled
            })
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/permissions/PermissionsBlock.js